import { render } from "./IconApple.vue?vue&type=template&id=cbfbf8c4"
import script from "./IconApple.vue?vue&type=script&lang=js"
export * from "./IconApple.vue?vue&type=script&lang=js"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__